export const MOBILE_SCREEN = 360;
export const MOBILE_TYPE = 'mobile';

export const TABLET_SCREEN = 768;
export const TABLET_TYPE = 'tablet';

export const DESKTOP_SCREEN = 1440;
export const DESKTOP_TYPE = 'desktop';
